import { SpinnerWrapper } from "./Style";

interface TmpSpinnerCustomProps {
   
}

export default function TmpSpinnerCustom(props: TmpSpinnerCustomProps) {

    return (
        <SpinnerWrapper data-testid="spinner">
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1.32686 9.17189C1.51958 10.2693 1.97997 11.3022 2.66725 12.1792C3.35452 13.0562 4.24747 13.7501 5.267 14.1996C6.28652 14.649 7.40116 14.8401 8.51217 14.7559C9.62318 14.6716 10.6963 14.3147 11.6364 13.7167C12.5765 13.1187 13.3546 12.2981 13.9018 11.3275C14.4491 10.3569 14.7485 9.2664 14.7735 8.15249C14.7986 7.03857 14.5486 5.93567 14.0456 4.94146C13.5426 3.94725 12.8022 3.09244 11.89 2.45273"
                    stroke="currentcolor"
                    strokeWidth="2.44949"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </SpinnerWrapper>
    );

}